import { TrashIcon } from '@common_components/icons/trash.icon';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ModalButton from '../buttons/modalButton.component';

interface ConfirmationModalProps {
  title: string;
  description: string;
  isOpen: boolean;
  onConfirm: () => void;
  onCancel?: () => void;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ( {
  title,
  description,
  isOpen,
  onConfirm,
  onCancel,
} ) => {
  const { t } = useTranslation();

  return (
    <>
      {
        isOpen && (
          <div className="fixed inset-0 z-[100] flex items-center justify-center">
            <div
              className="absolute inset-0 bg-black appear bg-opacity-40"
            />
            <div className="relative bg-white-base flex-col gap-4 rounded-xl flex shadow-xl p-6 w-full max-w-md z-[110]">
              <div className='flex gap-5 flex-center w-fit'>
                <div className='p-2 bg-red-100 rounded-full text-red-base w-fit h-fit aspect-square'>
                  <TrashIcon size={7}/>
                </div>
                <h2 className="text-xl font-semibold mb-2">{title}</h2>
              </div>
              <div>
                <p className="text-gray-700 mb-6">{description}</p>
                <div className="flex justify-end gap-4">
                  <ModalButton
                    label={t( 'common:cancel' )}
                    onClick={onCancel}
                    textColor="text-black"
                    shadow='shadow-none'
                    bgColor="bg-gray-base"
                    borderColor="border-transparent"
                    hoverBorderColor="hover:border-gray-base"
                  />

                  <ModalButton
                    label={t( 'common:confirm' )}
                    onClick={onConfirm}
                    textColor="text-white"
                    shadow='shadow-none'
                    bgColor="bg-red-500"
                    borderColor="border-transparent"
                    hoverBorderColor="hover:border-red-500"
                  />
                </div>
              </div>
            </div>
          </div>
        )
      }
    </>
  );
};

export default ConfirmationModal;
